<template>
  <v-dialog v-model="dialogSearch" max-width="1000px">
    <v-btn :ripple="false" slot="activator" class="btn--plain ma-0 pa-0" flat>
      <v-icon>search</v-icon>Search
    </v-btn>
    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-0">
        <h2>Advanced Search</h2>
      </v-card-title>
      <table class="v-datatable v-table mt-3">
        <tr
          :class="{
            'd-block': $vuetify.breakpoint.smAndDown,
            'd-flex': $vuetify.breakpoint.mdAndUp,
          }"
        >
          <td
            v-for="(fieldname, i) in keys"
            :key="i"
            :class="{
              'd-block': $vuetify.breakpoint.smAndDown,
              'd-flex': $vuetify.breakpoint.mdAndUp,
            }"
            @keyup.enter="fieldSearch()"
          >
            <v-text-field
              box
              :label="formatName(fieldname)"
              v-model="searchObj[fieldname]"
              class="mr-2"
            ></v-text-field>
          </td>
        </tr>
      </table>
      <v-data-table
        :headers="tableHeaders"
        :items="tableItems"
        class="my-custom-table in-container relation-field-search"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              style="text-align: left"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr>
            <td style="position: relative">
              <v-tooltip right color="secondary">
                <v-btn
                  @click="link(props.item.value)"
                  slot="activator"
                  icon
                  style="position: absolute; top: 5px; left: -5px"
                >
                  <v-icon color="secondary">link</v-icon>
                </v-btn>
                <span>Link case</span>
              </v-tooltip>
              <v-text-field
                box
                :label="formatName(keys[0])"
                v-model="props.item.value.properties[keys[0]]"
              ></v-text-field>
            </td>
            <td v-for="key in keys" :key="key">
              <v-text-field
                box
                :label="formatName(key)"
                v-model="props.item.value.properties[key]"
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions class="ma-0 mt-0 pa-0">
        <v-btn @click="dialogSearch = false" color="secondary">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Helpers from "@/helpers.js";

export default {
  name: "RelationFieldSearchDialog",
  methods: {
    formatName(name) {
      return Helpers.capitalizeRemoveUnderscores(name);
    },
    link(relatedCase) {
      this.$emit('link', relatedCase)
    },
    async fieldSearch() {
      const fieldsToReturn = this.keys;
      let searchTerm = "";
      const searchObj = this.searchObj;
      Object.keys(this.searchObj).forEach(function (field) {
        searchTerm += searchObj[field] + " ";
      });
      if (searchTerm === "") {
        searchTerm = "*";
      } // If empty, search all
      const searchData = {
        caseType: this.field.relation,
        page: 0,
        pageSize: Helpers.RELATION_LOOKUP_PAGE_SIZE,
        query: searchTerm,
        fieldsToReturn: fieldsToReturn,
      };
      const result = await this.$store.dispatch("getCaseSearch", searchData);
      const cases = [];
      result.forEach(function (item) {
        cases.push({ name: item.title, value: item, id: item._id });
      });
      this.tableItems = cases;
    },
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    caseType: {
      type: Object,
      required: true,
    },
    preferences: {
      type: Object,
      required: true,
    }
  },
  computed: {
    fields() {
      if (this.caseType && this.caseType.displayFields) {
        return this.caseType.displayFields;
      } else {
        return [];
      }
    },
    keys() {
      return this.fields.map((field) => field.fieldName);
    },
  },
  data: () => {
    return {
      tableHeaders: [],
      tableItems: [],
      dialogNew: false,
      dialogSearch: false,
      searchObj: {},
      quickSearchData: "",
      quickSearchCases: [],
      quickSearchSelection: {},
      summary: {},
    };
  },
};
</script>